

// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
// import { motion, AnimatePresence } from 'framer-motion';

// const logoImage = '/images/logo.png';

// const Header = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     setIsOpen(false);
//   }, [location]);

//   const navItems = [
//     { path: '/', label: 'Home' },
//     { path: '/about', label: 'About' },
//     { path: '/services', label: 'Services' },
//     { path: '/calculators', label: 'Calculators' },
//     { path: '/blogs', label: 'Blogs' },
//     { path: '/contact', label: 'Contact' },
//   ];

//   const isActive = (path) => location.pathname === path;

//   return (
//     <header className={`fixed w-full z-50 transition-all duration-300 ${
//       scrolled ? 'bg-white shadow-lg py-2' : 'bg-white py-4'
//     }`}>
//       <div className="container-custom">
//         <div className="flex justify-between items-center">
//           {/* Logo */}
//           <Link to="/" className="flex items-center space-x-3 group">
//             <motion.div 
//               whileHover={{ rotate: 360, scale: 1.1 }}
//               transition={{ duration: 0.5 }}
//               className="relative"
//             >
//               <img 
//                 src={logoImage} 
//                 alt="Wisdom Consultancy Logo" 
//                 className="w-12 h-12 object-contain rounded-full bg-blue-600 p-1 shadow-lg"
//                 onError={(e) => {
//                   e.target.style.display = 'none';
//                   e.target.parentElement.innerHTML = '<div class="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg"><span class="text-white font-bold text-2xl">W</span></div>';
//                 }}
//               />
//               <div className="absolute inset-0 rounded-full border-2 border-transparent group-hover:border-blue-400 transition-all duration-300"></div>
//             </motion.div>
            
//             <div>
//               <h1 className={`font-bold text-xl ${scrolled ? 'text-gray-900' : 'text-gray-900'}`}>
//                 Wisdom <span className="text-blue-600">Consultancy</span>
//               </h1>
//               <p className={`text-xs ${scrolled ? 'text-gray-500' : 'text-gray-500'}`}>
//                 SECURE YOUR FUTURE
//               </p>
//             </div>
//           </Link>

//           {/* Desktop Navigation */}
//           <nav className="hidden md:flex space-x-8">
//             {navItems.map((item) => (
//               <Link
//                 key={item.path}
//                 to={item.path}
//                 className={`font-medium transition-all duration-300 relative ${
//                   scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-gray-700 hover:text-blue-600'
//                 }`}
//               >
//                 {item.label}
//                 {isActive(item.path) && (
//                   <motion.div
//                     layoutId="activeNav"
//                     className="absolute bottom-[-4px] left-0 right-0 h-0.5 bg-blue-600"
//                     initial={{ scaleX: 0 }}
//                     animate={{ scaleX: 1 }}
//                     transition={{ duration: 0.3 }}
//                   />
//                 )}
//               </Link>
//             ))}
//           </nav>

//           {/* Get Started Button */}
//           <div className="hidden md:block">
//             <Link 
//               to="/contact" 
//               className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition-all transform hover:scale-105"
//             >
//               Get Started
//             </Link>
//           </div>

//           {/* Mobile Menu Button */}
//           <button
//             className="md:hidden text-2xl"
//             onClick={() => setIsOpen(!isOpen)}
//           >
//             {isOpen ? 
//               <AiOutlineClose className="text-gray-900" /> : 
//               <AiOutlineMenu className="text-gray-900" />
//             }
//           </button>
//         </div>

//         {/* Mobile Navigation */}
//         <AnimatePresence>
//           {isOpen && (
//             <motion.nav
//               initial={{ opacity: 0, height: 0 }}
//               animate={{ opacity: 1, height: 'auto' }}
//               exit={{ opacity: 0, height: 0 }}
//               className="md:hidden mt-4 pb-4 overflow-hidden bg-white rounded-lg shadow-lg"
//             >
//               {navItems.map((item) => (
//                 <Link
//                   key={item.path}
//                   to={item.path}
//                   className="block py-3 font-medium text-gray-700 hover:text-blue-600 transition-colors border-b border-gray-100"
//                   onClick={() => setIsOpen(false)}
//                 >
//                   {item.label}
//                 </Link>
//               ))}
//               <Link
//                 to="/contact"
//                 className="block mt-2 bg-blue-600 text-white text-center px-5 py-2 rounded-lg font-semibold"
//                 onClick={() => setIsOpen(false)}
//               >
//                 Get Started
//               </Link>
//             </motion.nav>
//           )}
//         </AnimatePresence>
//       </div>
//     </header>
//   );
// };

// export default Header;

// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
// import { motion, AnimatePresence } from 'framer-motion';

// const logoImage = '/images/logo.png';

// const Header = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     setIsOpen(false);
//   }, [location]);

//   const navItems = [
//     { path: '/', label: 'Home' },
//     { path: '/about', label: 'About' },
//     { path: '/services', label: 'Services' },
//     { path: '/calculators', label: 'Calculators' },
//     { path: '/blogs', label: 'Blogs' },
//     { path: '/contact', label: 'Contact' },
//   ];

//   const isActive = (path) => location.pathname === path;

//   return (
//     <header className={`fixed w-full z-50 transition-all duration-300 ${
//       scrolled ? 'bg-white shadow-lg py-2' : 'bg-white py-4'
//     }`}>
//       <div className="container-custom">
//         <div className="flex justify-between items-center">
//           {/* Logo */}
//           <Link to="/" className="flex items-center space-x-3">
//             <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
//               <img 
//                 src={logoImage} 
//                 alt="Wisdom Consultancy Logo" 
//                 className="w-full h-full object-contain"
//                 onError={(e) => {
//                   e.target.style.display = 'none';
//                   e.target.parentElement.innerHTML = '<div class="w-10 h-10 md:w-12 md:h-12 bg-blue-600 rounded-lg flex items-center justify-center"><span class="text-white font-bold text-lg md:text-xl">W</span></div>';
//                 }}
//               />
//             </div>
//             <div>
//               <h1 className={`font-bold text-base md:text-xl ${scrolled ? 'text-gray-900' : 'text-gray-900'}`}>
//                 Wisdom <span className="text-blue-600">Consultancy</span>
//               </h1>
//               <p className={`text-[10px] md:text-xs ${scrolled ? 'text-gray-500' : 'text-gray-500'}`}>
//                 SECURE YOUR FUTURE
//               </p>
//             </div>
//           </Link>

//           {/* Desktop Navigation */}
//           <nav className="hidden md:flex space-x-6 lg:space-x-8">
//             {navItems.map((item) => (
//               <Link
//                 key={item.path}
//                 to={item.path}
//                 className={`font-medium transition-all duration-300 relative ${
//                   scrolled ? 'text-gray-700 hover:text-blue-600' : 'text-gray-700 hover:text-blue-600'
//                 }`}
//               >
//                 {item.label}
//                 {isActive(item.path) && (
//                   <motion.div
//                     layoutId="activeNav"
//                     className="absolute bottom-[-4px] left-0 right-0 h-0.5 bg-blue-600"
//                     initial={{ scaleX: 0 }}
//                     animate={{ scaleX: 1 }}
//                     transition={{ duration: 0.3 }}
//                   />
//                 )}
//               </Link>
//             ))}
//           </nav>

//           {/* Get Started Button */}
//           <div className="hidden md:block">
//             <Link 
//               to="/contact" 
//               className="bg-blue-600 text-white px-5 py-2 rounded-lg font-semibold hover:bg-blue-700 transition-all"
//             >
//               Get Started
//             </Link>
//           </div>

//           {/* Mobile Menu Button */}
//           <button
//             className="md:hidden text-2xl"
//             onClick={() => setIsOpen(!isOpen)}
//           >
//             {isOpen ? 
//               <AiOutlineClose className="text-gray-900" /> : 
//               <AiOutlineMenu className="text-gray-900" />
//             }
//           </button>
//         </div>

//         {/* Mobile Navigation */}
//         <AnimatePresence>
//           {isOpen && (
//             <motion.nav
//               initial={{ opacity: 0, height: 0 }}
//               animate={{ opacity: 1, height: 'auto' }}
//               exit={{ opacity: 0, height: 0 }}
//               className="md:hidden mt-4 pb-4 overflow-hidden bg-white rounded-lg shadow-lg"
//             >
//               {navItems.map((item) => (
//                 <Link
//                   key={item.path}
//                   to={item.path}
//                   className="block py-3 font-medium text-gray-700 hover:text-blue-600 transition-colors border-b border-gray-100"
//                   onClick={() => setIsOpen(false)}
//                 >
//                   {item.label}
//                 </Link>
//               ))}
//               <Link
//                 to="/contact"
//                 className="block mt-2 bg-blue-600 text-white text-center px-5 py-2 rounded-lg font-semibold"
//                 onClick={() => setIsOpen(false)}
//               >
//                 Get Started
//               </Link>
//             </motion.nav>
//           )}
//         </AnimatePresence>
//       </div>
//     </header>
//   );
// };

// export default Header;

import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  AiOutlineMenu,
  AiOutlineClose,
} from 'react-icons/ai';

import {
  FaPhoneAlt,
  FaEnvelope,
} from 'react-icons/fa';

import {
  motion,
  AnimatePresence,
} from 'framer-motion';

const logoImage = '/images/logo.png';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };

    window.addEventListener('scroll', handleScroll);

    return () =>
      window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/calculators', label: 'Calculators' },
    { path: '/blogs', label: 'Blogs' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) =>
    location.pathname === path;

  return (
    <>
      {/* Top Bar */}
      <div className="hidden md:block bg-primary text-white text-sm py-2">
        <div className="container-custom flex justify-between items-center">
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <FaPhoneAlt className="text-xs" />
              <span>+91 9726344477</span>
            </div>

            <div className="flex items-center gap-2">
              <FaEnvelope className="text-xs" />
              <span>wisdom2secure@gmail.com</span>
            </div>
          </div>

          <div>
            <span>
              Secure Your Future with Smart Financial Planning
            </span>
          </div>
        </div>
      </div>

      {/* Header */}
      <header
        className={`fixed w-full z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-white/95 backdrop-blur-md shadow-lg py-2'
            : 'bg-white py-4'
        }`}
      >
        <div className="container-custom">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <Link
              to="/"
              className="flex items-center space-x-3"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center overflow-hidden rounded-xl">
                <img
                  src={logoImage}
                  alt="Wisdom Consultancy"
                  className="w-full h-full object-contain"
                />
              </div>

              <div>
                <h1 className="font-bold text-lg md:text-2xl text-gray-900 leading-tight">
                  Wisdom{' '}
                  <span className="text-blue-600">
                    Consultancy
                  </span>
                </h1>

                <p className="text-[10px] md:text-xs text-gray-500 tracking-widest">
                  SECURE YOUR FUTURE
                </p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-8">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`relative font-medium transition-all duration-300 ${
                    isActive(item.path)
                      ? 'text-blue-600'
                      : 'text-gray-700 hover:text-blue-600'
                  }`}
                >
                  {item.label}

                  {isActive(item.path) && (
                    <motion.div
                      layoutId="activeNav"
                      className="absolute -bottom-1 left-0 right-0 h-[2px] bg-blue-600 rounded-full"
                      initial={{ scaleX: 0 }}
                      animate={{ scaleX: 1 }}
                      transition={{ duration: 0.3 }}
                    />
                  )}
                </Link>
              ))}
            </nav>

            {/* CTA Button */}
            <div className="hidden md:block">
              <Link
                to="/contact"
                className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
              >
                Get Free Consultation
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-3xl text-gray-800"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? (
                <AiOutlineClose />
              ) : (
                <AiOutlineMenu />
              )}
            </button>
          </div>

          {/* Mobile Menu */}
          <AnimatePresence>
            {isOpen && (
              <motion.div
                initial={{
                  opacity: 0,
                  y: -20,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                }}
                exit={{
                  opacity: 0,
                  y: -20,
                }}
                transition={{ duration: 0.3 }}
                className="md:hidden mt-4 bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100"
              >
                <div className="flex flex-col p-4">
                  {navItems.map((item, index) => (
                    <motion.div
                      key={item.path}
                      initial={{
                        opacity: 0,
                        x: -20,
                      }}
                      animate={{
                        opacity: 1,
                        x: 0,
                      }}
                      transition={{
                        delay: index * 0.05,
                      }}
                    >
                      <Link
                        to={item.path}
                        className={`block px-4 py-3 rounded-lg font-medium transition-all ${
                          isActive(item.path)
                            ? 'bg-blue-50 text-blue-600'
                            : 'text-gray-700 hover:bg-gray-50 hover:text-blue-600'
                        }`}
                      >
                        {item.label}
                      </Link>
                    </motion.div>
                  ))}

                  <Link
                    to="/contact"
                    className="mt-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-center px-5 py-3 rounded-xl font-semibold shadow-md"
                  >
                    Get Free Consultation
                  </Link>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </header>
    </>
  );
};

export default Header;